export default __webpack_public_path__ + "static/description-template-30e21ca5328064d8789a3f065975afef.jpg";